<template>
  <div>
    <home />
    <about />
    <pricing />
    <contact />
  </div>
</template>

<script>
import foote from "../Footer";
import home from "../HomeSection";
import about from "../AboutSection";
import navigation from "../Navigation";
import pricing from "../Pricing/PricingSection";
import contact from "../ContactSection";

export default {
  name: "App",

  components: {
    navigation,
    foote,
    home,
    about,
    /* download, */
    pricing,
    contact,
  },

  data: () => ({
    fab: null,
    color: "",
    flat: null,
  }),

  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style scoped>
@import url("https://use.fontawesome.com/releases/v5.8.2/css/all.css");
.v-main {
  /* background-image: url("~@/assets/img/bgMain.png"); */
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}
</style>
